'use client';

// components/Layout.tsx
import React from 'react'
import { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';
import { AriaProvider } from '@/context/AriaContext';
import { AriaInteraction } from '@/components/Aria/AriaInteraction';
import styles from './Layout.module.css';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <AriaProvider>
      <div className={styles.container}>
        <Header />
        <main className={styles.main}>
          {/* AI Agent Container */}
          <div className={styles.ariaContainer}>
            <AriaInteraction 
              config={{
                initialState: 'idle',
                avatarSize: 'medium',
                position: 'bottom-right',
                theme: {
                  primaryColor: '#5f4664',
                  secondaryColor: '#c39bd3',
                },
                animations: {
                  enabled: true,
                  preload: ['idle', 'speaking', 'listening', 'thinking'],
                  format: 'video'
                }
              }}
            />
          </div>
          {children}
        </main>
        <Footer />
      </div>
    </AriaProvider>
  );
};

export default Layout;